<template>
	<div class="margin-top-10">
		<a class="padding-8 pointer" @click="backToList()">
			<i class="arrow left"></i>	Back To Automation List
		</a>
		<div class="padding-10 ">
			<section class="option_section width-60">
			<input ref="rule_name" id="rule_name" placeholder="Automation Name"  name="rule_name" v-validate="'required'" v-model="automation_rule.name" class="background-what-section border-none height-40 width-60 input-font" type="text"/>
			</section>
			<section v-if="errors.first('rule_name')">
			<span class="input-error-plain mr-3">Name is required</span>

			</section>
			<div  class="flex-fix padding-12-top-bottom">
			<div class="font-16 font-gilroy font-weight-500" v-html="rule_sentence">
					{{rule_sentence}}
			</div>
				<button :class="{'not-allowed input-disabled': !create_save_button_condition}"  @click="openCreateModal()" class="button background-create padding-12 content-right-align height-40"> {{continue_button_text}} </button>
			</div>
			<a @click="whoClicked('who')">
				<automation-who @updateWHOcondition="updateWHOcondition" :edit_view="edit_view" @updateWhoAPI="updateWhoAPI" :automation_edit_detail="automation_edit_filter" :active="rule_groups.who"></automation-who>
			</a>
			<a @click="whoClicked('when')">
				<automation-when @updateWHENcondition="updateWHENcondition" :edit_view="edit_view" :automation_edit_detail="automation_edit_events" @updateWhenAPI="updateWhenAPI" :active="rule_groups.when"></automation-when>
			</a>
			<a @click="whoClicked('what')">
				<automation-what :edit_view="edit_view" :automation_edit_detail="automation_edit_actions" @updateWHATcondition="updateWHATcondition" @updateWhatAPI="updateWhatAPI" :active="rule_groups.what"></automation-what>
			</a>
			
		</div>
		<!-- <div  class="flex-fix padding-12">
			<div class="font-16 font-gilroy font-weight-500" v-html="rule_sentence">
					{{rule_sentence}}
			</div>
				<button :class="{'not-allowed input-disabled': !create_save_button_condition}"  @click="openCreateModal()" class="button background-create padding-12 content-right-align height-40"> {{continue_button_text}} </button>
		</div> -->
		<div v-if="create_modal">
			<create-automation-modal :rule_sentence="rule_sentence" :edit_view="edit_view" :automation_rule="automation_rule" :create_modal="create_modal" @backToList="backToList" @closeModal="closeModal"></create-automation-modal>
		</div>
	</div>
</template>
<script>
import FilterGroup from './FilterGroup'
import automationWho from './automationGroups/WHO/automationWho.vue'
import automationWhen from './automationGroups/WHEN/automationWhen'
import automationWhat from './automationGroups/WHAT/automationWhat'
import createAutomationModal from './automationSharedView/createAutomoationModal'
import automationMixin from './automationMixin'
export default {
	components : {
		FilterGroup,
		automationWho,
		automationWhen,
		automationWhat,
		createAutomationModal
	},
	props:{
		automation_edit_detail:{
			required: false
		}
	},
	mixins: [automationMixin],
	data : function(){
		return{
			continue_button_text: 'CREATE',
			rule_groups:{ 
				 who: true,
				 when: false,
				 what: false
			},
			rule_validations:{
				who: false,
				what: false,
				when: false
			},
			automation_rule:{
				name:'',
				is_active: 1,
				events:[]
			},
			automation_detail_view:'',
			create_modal:false,
			edit_view: false,
			user_role: this.$store.getters.getRole,
			rule_sentence:''
		}
	},
	computed : {
		create_save_button_condition(){
			return this.rule_validations.who && this.rule_validations.what && this.rule_validations.when && (this.automation_rule.name != '')
		},
		edit_view_check(){
			if(this.automation_edit_detail){
				if(this.automation_edit_detail.raw_rule){
					this.automation_rule.filters = this.automation_edit_detail.raw_rule.filters
					this.automation_rule.events = this.automation_edit_detail.raw_rule.events
					this.automation_rule.actions = this.automation_edit_detail.raw_rule.actions
					this.automation_rule.id = this.automation_edit_detail.id
					this.automation_rule.is_active = this.automation_edit_detail.is_active
					this.automation_rule.name = this.automation_edit_detail.name
					this.continue_button_text = "SAVE"
					this.rule_groups.when = true
					this.rule_groups.what = true
					this.edit_view = true
					return true
				}else{
					this.continue_button_text = "CREATE"
					this.edit_view = false
					return false
				}
			}else{
				return false
			}

		},
		automation_edit_filter(){
			if(this.automation_edit_detail){
				if(this.automation_edit_detail.raw_rule && this.automation_edit_detail.raw_rule.filters){
					return this.automation_edit_detail.raw_rule.filters
				}else{
					return null
				}
			}else{
				return null
			}
		},
		automation_edit_events(){
			if(this.automation_edit_detail){
				if(this.automation_edit_detail.raw_rule && this.automation_edit_detail.raw_rule.events){
					return this.automation_edit_detail.raw_rule.events
				}else{
					return null
				}
			}else{
				return null
			}
		},
		automation_edit_actions(){
			if(this.automation_edit_detail){
				if(this.automation_edit_detail.raw_rule && this.automation_edit_detail.raw_rule.actions){
					return this.automation_edit_detail.raw_rule.actions
				}else{
					return null
				}
			}else{
				return null
			}
		}
	},

	mounted(){
		if(this.automation_edit_detail){
			//get the first AND/OR
			this.automation_rule.name = this.automation_edit_detail.name
		}
		this.moveFocus()
	},
	watch:{
		edit_view_check(val){
			//watch for edit
		},
		automation_rule:{
			handler(val){
			},
			deep: true
		}
		
	},
	methods : {
		moveFocus(){
			setTimeout( () => {
				if(!this.automation_edit_detail){
					this.$refs.rule_name.focus()
				}
			},1000)
		},
		updateWhoAPI(filters){
			this.automation_rule.filters = filters
			this.getRuleSentence()
			this.$forceUpdate()
		},
		updateWhenAPI(event){
			let temp_arr = []
			temp_arr.push(event)
			this.automation_rule.events = temp_arr
			this.getRuleSentence()
			this.$forceUpdate()
		},
		updateWhatAPI(actions){
			this.automation_rule.actions = actions
			this.getRuleSentence()
			this.$forceUpdate()
		},
		whoClicked(group_name){
			this.removeActiveColor(group_name)
		},
		removeActiveColor: function(only_stay_element){
			for (const key in this.rule_groups) {
				if(key == only_stay_element){
					this.rule_groups[key] = true
				}else{
					this.rule_groups[key] = false
				}
			}
		},
		getRuleSentence(){
			if(this.user_role ==  'csm' || this.user_role == 'admin'){
				this.automation_rule.organization_id = this.id
			}
			
			this.$store.dispatch('getAutomationRuleSenctence', this.automation_rule).then((res) => {
				this.rule_sentence = res.data
			}).catch((error) => {
				console.log(error);
			});

		},
		openCreateModal(){
			if(this.user_role ==  'csm' || this.user_role == 'admin'){
				this.automation_rule.organization_id = this.id
			}
			
			let api_call = ''

			if(this.edit_view){
				api_call = 'editAutomationRule'
			}else{
				this.automation_rule.is_active = 0
				api_call = 'createAutomationRules'
			}

			this.$store.dispatch(api_call, this.automation_rule).then((res) => {
				this.create_modal = true
				this.automation_rule.id = res.data.automation_rule.id
			}).catch((error) => {
				console.log(error);
			});
		},
		updateWHATcondition(cond){
			this.rule_validations.what = cond
		},
		updateWHENcondition(cond){
			this.rule_validations.when = cond
		},
		updateWHOcondition(cond){
			this.rule_validations.who = cond
		},
		closeModal(){
			this.create_modal = false
		},
		backToList(){
			this.automation_rule = {
				name:'',
				is_active: 1,
				events:[]
			}
			this.$store.commit('setCurrentFilter', null)
			this.$emit('openAutomationList')
		}
	}
	
}
</script>
<style src="./automation.css">

</style>


// WEBPACK FOOTER //
// src/components/automation/AutomationCreate.vue